<template>
  <v-container fluid>
    <v-card class="pa-6" v-if="otfCheck">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Immigration Docket</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6">
          <v-btn @click="openaddItem()" color="#0A7EA5" rounded dark class="mb-2" :disabled="!authorize_add">
            <span>Add</span>
            <v-icon small center>add</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field v-model="search" append-icon="mdi-magnify"
                label="Search" single-line hide-details outlined
                dense clearable @keyup.enter="findAllByAPISearch" @click:append="findAllByAPISearch"
                @click:clear="$nextTick(() => { search = ''; findAllByAPISearch(); })"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <!-- <v-autocomplete
                  v-model="search"
                  :items="status"
                  label="Status"
                  outlined
                  dense
                ></v-autocomplete> -->
            </v-col>
            <!-- <v-col cols="12" md="1"> </v-col> -->
          </v-row>
        </v-col>
        <!-- <v-col cols="12" md="4" class="d-flex justify-end mb-6"> -->
          <!-- <v-btn class="mr-2" @click="showsearchmore">
              filter
              <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
            </v-btn> -->
        <!-- </v-col> -->
                <v-col cols="12" md="3">
          <v-select v-model="filterWorkType" :items="workTypeOptions" label="Work Type" outlined dense clearable hide-details></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select v-model="filterStatus" :items="statusOptions" label="Status" outlined dense clearable hide-details></v-select>
        </v-col>
      </v-row>
      <v-row v-show="toggleEnable">
        <v-col cols="12" md="6"> </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddatefromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  "></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computeddateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  "></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <br />

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
          item-value="id"
          show-select
          v-model="selectedItems"
        >
          <template v-slot:item.invoice_no="{ item }">
            <div v-if="item.invoice_no">
              <div
                v-for="(inv, index) in item.invoice_no.split(',')"
                :key="index"
              >
                {{ inv }}
              </div>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
              }"
              @click="openeditItem(item.id)"
              v-if="authorize_edit"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              class="ml-1"
              :style="{
                backgroundColor: '#FFEBEE',
                color: '#F44336',
              }"
              @click="deleteItem(item.id)"
              v-if="authorize_del"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="filteredTableData" :server-items-length="totalItems"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait" item-value="id" show-select
            v-model="selectedItems">
            <!-- <v-data-table
            :headers="headers"
            :items="filteredData"
            :server-items-length="filteredData.length"
            :options.sync="options"
            @update:options="onOptionsUpdate"
            hide-default-footer
            class="elevation-1"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            item-value="id"
            show-select
            v-model="selectedItems"
          > -->
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>

            <template v-slot:item.invoice_no="{ item }">
              <div v-if="item.invoice_no">
                <div v-for="(inv, index) in item.invoice_no.split(',')" :key="index">
                  {{ inv }}
                </div>
              </div>
              <div v-else>-</div>
              <!-- กรณีไม่มี invoice_no -->
            </template>
            <template v-slot:item.invoice_status="{ item }">
              <div v-if="item.invoice_no">
                <div v-for="(inv_status, index) in item.invoice_status.split(',')" :key="index">
                  {{ inv_status }}
                </div>
              </div>
              <div v-else>-</div>
              <!-- กรณีไม่มี invoice_no -->
            </template>
            <template v-slot:item.visa_expiry="{ item }">
              <span :class="expiryClass(item.visa_expiry)">{{ fmtDate(item.visa_expiry) }}</span>
            </template>
            <template v-slot:item.wp_expiry="{ item }">
              <span :class="expiryClass(item.wp_expiry)">{{ fmtDate(item.wp_expiry) }}</span>
            </template>
            <template v-slot:item.ltr_expiry="{ item }">
              <span :class="expiryClass(item.ltr_expiry)">{{ fmtDate(item.ltr_expiry) }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="ml-1" :style="{
                backgroundColor: '#E1F5FE',
                color: '#2196F3',
              }" @click="openeditItem(item.id)" v-if="authorize_edit">
                mdi-pencil
              </v-icon>

              <v-icon class="ml-1" :style="{
                backgroundColor: '#FFEBEE',
                color: '#F44336',
              }" @click="deleteItem(item.id)" v-if="authorize_del">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-row justify="center" style="margin-top: 40px">
        <v-btn @click="onSavePayMent()" color="#0A7EA5" rounded dark class="mb-2" :disabled="!authorize_add">
          <span>Payment Request</span>
        </v-btn>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOTPVerification" max-width="340px" persistent @input="startCountdown()">
      <v-card class="justify-center align-center">
        <v-card-title class="text-h5 justify-center align-center">
          OTP Verification
        </v-card-title>

        <v-row class="ma-0 justify-center align-center">
          Enter the OTP you received at
        </v-row>
        <v-row class="ma-0 justify-center align-center">
          <strong>{{ dataotp.email }}</strong>
        </v-row>
        <v-row class="ma-0 justify-center align-center">
          (Ref:{{ dataotp.refOtp }})
        </v-row>

        <!-- แสดงเวลานับถอยหลัง -->
        <v-row class="ma-0 justify-center align-center mt-2">
          <span v-if="countdown > 0">OTP expires in <strong>{{ countdown }}</strong> seconds</span>
          <span v-else class="text-red"> OTP expired. Request a new one. </span>
          <v-btn color="green darken-1" text @click="resendOTP" v-if="countdown === 0">Resend OTP</v-btn>
        </v-row>

        <!-- กล่อง OTP -->
        <v-row class="ma-0 justify-center align-center mt-2">
          <v-col v-for="(otp, index) in 6" :key="index" cols="2">
            <v-text-field v-model="sendotpdata[`otp${index + 1}`]" :key="index" :ref="`otp${index + 1}`"
              class="justify-center text-center" maxlength="1" outlined dense hide-details :disabled="countdown === 0"
              @input="handleInput(index)" :autofocus="index == 0"></v-text-field>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="sendOTPConfirm" :disabled="countdown === 0">Confirm OTP</v-btn>
          <v-btn color="red darken-1" text @click="goToDashboard">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";
import unity from "@/unity/unity";

export default {
  name: "invoice",
  data(vm) {
    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],
      filterWorkType: null,
      filterStatus: null,

      selectedItems: [],
      otfCheck: false,
      sendotpdata: {
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: "",
      },
      showfilenameappointment: "",
      dataotp: [],
      dialogOTPVerification: false,
      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      menu: false,
      menu2: false,
      toggleEnable: false,
      search: "",
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [
        // {
        //   file_no: "GA-001",
        //   client_name: "client_name1",
        //   company: "company1",
        //   id: "97",
        //   date_show: new Date(
        //     Date.now() - new Date().getTimezoneOffset() * 60000
        //   )
        //     .toISOString()
        //     .substr(0, 10),
        //   Company: "testcus1",
        //   agency: "agency1",
        //   case_worker: "case_worker1",
        //   status: "Draft",
        // },
        // {
        //   file_no: "GA-002",
        //   client_name: "client_name2",
        //   company: "cus123",
        //   id: "97",
        //   date_show: new Date(
        //     Date.now() - new Date().getTimezoneOffset() * 60000
        //   )
        //     .toISOString()
        //     .substr(0, 10),
        //   Company: "company2",
        //   agency: "agency2",
        //   case_worker: "case_worker2",
        //   status: "Draft",
        // },
      ],

      headers: [
        // {
        //   text: "ID.",
        //   value: "id",
        //   class: "bg-colorth tabletextwhite",
        //   width: "70px",
        // },
        {
          text: "Work Type",
          value: "work_type_name",
          class: "bg-colorth tabletextwhite",
          // width: "110px",
        },
        {
          text: "File No",
          value: "file_no",
          class: "bg-colorth tabletextwhite",
          // width: "140px",
        },
        {
          text: "Principal Applicant",
          value: "principal_applicant",
          class: "bg-colorth tabletextwhite",
          // width: "150px",
        },

        {
          text: "Client Name",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
          // width: "200px",
        },
        {
          text: "Host Company",
          value: "company_name_show",
          class: "bg-colorth tabletextwhite",
          // width: "150px",
        },
        // {
        //   text: "Priciple / Urgent Client",
        //   value: "priciple_name",
        //   class: "bg-colorth tabletextwhite",
        //   width: "200px",
        // },
        // {
        //   text: "Quotations No.",
        //   value: "quotation_doc_no",
        //   class: "bg-colorth tabletextwhite",
        //   width: "150px",
        // },
        {
          text: "Visa Expiry",
          value: "visa_expiry",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "WP Expiry",
          value: "wp_expiry",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "LTR Expiry",
          value: "ltr_expiry",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Invoice No.",
          value: "invoice_no",
          class: "bg-colorth tabletextwhite",
          // width: "150px",
        },
        {
          text: "Invoice Status",
          value: "invoice_status",
          class: "bg-colorth tabletextwhite",
          // width: "150px",
        },
          {
          text: "Case Worker(s)",
          value: "case_worker",
          class: "bg-colorth tabletextwhite",
          // width: "120px",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
          // width: "90px",
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          width: "90px",
          sortable: false,
        },
      ],
      editedIndex: -1,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",

      countdown: 180, // เริ่มต้นที่ 60 วินาที
      timer: null,
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  computed: {
    workTypeOptions() {
      return this.uniqueValues("work_type_name");
    },
    statusOptions() {
      return this.uniqueValues("status");
    },
    filteredTableData() {
      return this.mDataArray2.filter(
        (item) =>
          (!this.filterWorkType || item.work_type_name === this.filterWorkType) &&
          (!this.filterStatus || item.status === this.filterStatus),
      );
    },
    filteredData() {
      if (!this.search) {
        return this.mDataArray2;
      }

      const searchLower = this.search.toLowerCase();
      return this.mDataArray2.filter((item) => {
        // ค้นหาจากทุก field ที่อยู่ใน headers (ยกเว้น actions)
        return this.headers.some((header) => {
          if (header.value === "actions") return false;
          const value = item[header.value];
          return value && value.toString().toLowerCase().includes(searchLower);
        });
      });
    },
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // // ----------------- Check Authorize ---------------------------

    // let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.checkotpverification();
    // await this.getAlllist();
    this.$hideLoader();
    this.$nextTick(() => {
      this.$refs[`otp1`][0].focus();
    });
  },
  methods: {
    // YYYY-MM-DD → DD/MM/YYYY
    fmtDate(s) {
      if (!s) return "-";
      const [y, m, d] = String(s).substr(0, 10).split("-");
      return `${d}/${m}/${y}`;
    },
    // หมดอายุแล้ว = แดง, ภายใน 30 วัน = ส้ม
    expiryClass(s) {
      if (!s) return "";
      const today = moment().tz("Asia/Bangkok").format("YYYY-MM-DD");
      const soon = moment().tz("Asia/Bangkok").add(30, "days").format("YYYY-MM-DD");
      const d = String(s).substr(0, 10);
      if (d < today) return "red--text font-weight-bold";
      if (d <= soon) return "orange--text text--darken-2 font-weight-bold";
      return "";
    },
    uniqueValues(key) {
      return [
        ...new Set(this.mDataArray2.map((item) => item[key]).filter(Boolean)),
      ].sort();
    },

    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getAllim_docket_CompanyPaginationV2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      /*
         page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getAllim_docket_CompanyPaginationV2(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getAllim_docket_CompanyPaginationV2(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "id",
        sortOrder: "ASC",
        company_id: localStorage.getItem(server.COMPANYID),
      };

      try {
        const result = await api.getAllim_docket_CompanyPaginationV2(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortOrder,
          s_data.company_id,
          this.search
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async handleInput(index) {
      if (
        Number(this.sendotpdata[`otp${index + 1}`]) ||
        this.sendotpdata[`otp${index + 1}`] == "0"
      ) {
        this.$nextTick(() => {
          this.$refs[`otp${index + 2}`][0].focus();
        });
      } else {
        this.$nextTick(() => {
          this.$refs[`otp${index + 1}`][0].focus();
        });
      }
      //       if(Number(index) == 0){
      //         this.$refs.otp2[0].focus();
      //       }else if(Number(index) == 1){
      //       this.$refs.otp3[0].focus();
      //       }else if(Number(index) == 2){
      //   this.$refs.otp4[0].focus();
      //       }else if(Number(index) == 3){
      //   this.$refs.otp5[0].focus();
      //       }else if(Number(index) == 4){
      //   this.$refs.otp6[0].focus();
      //       }else if(Number(index) == 5){
      //   // this.$refs.otp1[0].focus();
      //       }else{
      // this.$refs.otp1[0].focus();
      //       }
    },
    resendOTP() {
      this.sendotpdata = {
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: "",
      };
      this.checkotpverification();
      this.startCountdown();
    },
    startCountdown() {
      if (this.timer) clearInterval(this.timer);
      this.countdown = 180;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.$showLoader();
          clearInterval(this.timer);
          this.$hideLoader();
        }
      }, 1000);
    },

    goToDashboard() {
      this.$router.push("/dashboard"); // '/dashboard' คือเส้นทาง (route) ของหน้า Dashboard
    },
    async deleteItem(id) {
      this.editedIndex = id;
      this.dialogDelete = true;
    },
    async closeDelete() {
      this.editedIndex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      this.mDataArray.forEach((x, index) => {
        if (x.id == this.editedIndex) {
          this.mDataArray.splice(index, 1);
        }
      });
      var res_transaction_id_del = this.editedIndex;
      // var res_transaction_dependent_id_del =
      //   await api.getdataByIdim_docket_dependent(this.editedIndex);

      // await api.deleteim_docket_dependent(this.editedIndex);
      const res_del = await api.deleteim_docket(this.editedIndex);

      this.closeDelete();

      if (res_del.status == 200 || res_del.status == 201) {
        var dataAddTransection = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Delete",
          table_name: "im_docket",
          table_id: res_transaction_id_del,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };
        // await api.addTransectionLog(dataAddTransection);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        // for (const [
        //   index,
        //   item,
        // ] of res_transaction_dependent_id_del.data.entries()) {
        //   var dataAddParticipant = {
        //     user_id: localStorage.getItem(server.USER_ID),
        //     log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        //     action: "Delete",
        //     table_name: "im_docket_Dependent",
        //     table_id: item.id,
        //     date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        //   };
        //   await api.addTransectionLog(dataAddParticipant);

        //   var dataEditLog = {
        //     last_update: moment()
        //       .tz("Asia/Bangkok")
        //       .format("YYYY-MM-DD HH:mm:ss"),
        //   };
        //   await api.updateLogInOutLog(
        //     localStorage.getItem(server.LOGIN_ID),
        //     dataEditLog
        //   );
        // }

        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Delete data success",
          "text-h5 green--text text-center"
        );
        this.initialize();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Delete data Failed",
          "text-h5 red--text text-center"
        );
      }
    },
    async sendOTPConfirm() {
      let allotpnumber =
        this.sendotpdata.otp1 +
        this.sendotpdata.otp2 +
        this.sendotpdata.otp3 +
        this.sendotpdata.otp4 +
        this.sendotpdata.otp5 +
        this.sendotpdata.otp6;
      if (allotpnumber == this.dataotp.otp_number) {
        const result = await api.updateotpverification(
          this.dataotp.user_otp_verification_id,
          { status: 2 }
        );
        if (result.status == 200 || result.status == 201) {
          this.dialogOTPVerification = false;
          this.otfCheck = true;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "OTP Verification success",
            "text-h5 green--text text-center"
          );
        } else {
          // this.dialogOTPVerification = false;
          // this.$store.state.global_push_dialog = true;
          //   this.setupAlertDialogPush(
          //     true,
          //     "Failed!!!",
          //     "OTP Verification Failed",
          //     "text-h5 red--text text-center",
          //     "/dashboard"
          //   );
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "OTP Verification Failed",
            "text-h5 red--text text-center"
          );
        }
      } else {
        // this.dialogOTPVerification = false;
        (this.sendotpdata = {
          otp1: "",
          otp2: "",
          otp3: "",
          otp4: "",
          otp5: "",
          otp6: "",
        }),
          (this.$store.state.global_dialog = true);
        this.setupAlertDialog(
          true,
          "Failed",
          "OTP Verification Failed",
          "text-h5 red--text text-center"
        );
      }
    },
    async checkotpverification() {
      // const result = await api.getcheckotpverification(
      //   localStorage.getItem(server.USER_ID)
      // );
      // if (result.data.length > 0 && result.data[0].status == 1) {
      //   this.dataotp = result.data[0];
      //   // this.$nextTick(() => this.$refs.otp1.$refs.input.focus());
      //   this.dialogOTPVerification = true;
      // } else {
      //   this.otfCheck = true;
      // }
      this.otfCheck = true;
    },
    async getAlllist() {
      //
      const result = await api.getAllim_docket_Company({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.mDataArray = result.data;
    },
  openaddItem(id) {
      // this.$router.push(`/immigration-docket-edit/${id}`);
      window.open(`/immigration-docket-add`);
    },
    openeditItem(id) {
      // this.$router.push(`/immigration-docket-edit/${id}`);
      window.open(`/immigration-docket-edit/${id}`);
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    editItem() { },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    onSavePayMent() {
      if (this.selectedItems.length === 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Kindly select at least one item to proceed.",
          "text-h5 red--text text-center"
        );
        return;
      }

      const firstCustomerId = this.selectedItems[0].customer_id;
      const isSameCustomer = this.selectedItems.every(
        (item) => item.customer_id === firstCustomerId
      );

      if (!isSameCustomer) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select items from the same customer only.",
          "text-h5 red--text text-center"
        );
        return;
      }

      const firstQuotationsId = this.selectedItems[0].quotations_id;
      const isSameQuotations = this.selectedItems.every(
        (item) => item.quotations_id === firstQuotationsId
      );

      if (!isSameQuotations) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please select items from the same quotation only.",
          "text-h5 red--text text-center"
        );
        return;
      }

      var customerId = firstCustomerId;
      var quotationsId = firstQuotationsId;
      var customerName = this.selectedItems[0].customer_name;

      var selectedModuleIds = this.selectedItems.map((item) => item.id);

      var moduleIds = Array.isArray(selectedModuleIds)
        ? [...selectedModuleIds]
        : [];

      var dataPush = {
        customer_name_master: customerName,
        module_id: moduleIds.join(","), // ส่งเป็น "1,2,3,99999"
        quotation_id: Number(quotationsId),
      }
      this.$router.push({
        path: `/new-free-invoice/0/invoice/D/${customerId}/Immigration`,
        query: dataPush,
      });
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  watch: {
    // รับ status จาก query เช่น /immigration-docket?status=ongoing
    statusOptions(options) {
      const q = (this.$route.query.status || "").toString().toLowerCase();
      if (!q || this.filterStatus) return;
      const match = options.find((s) => s.toLowerCase().startsWith(q));
      if (match) this.filterStatus = match;
    },
    dialogOTPVerification(val) {
      if (val) this.startCountdown();
    },
  },
};
</script>

<style scoped></style>